<template>
  <component :is="template"/>
</template>

<script>
import AuthTemplate from 'views/AuthTemplate'
import MainTemplate from 'views/MainTemplate'

export default {
  computed: {
    template () {
      if (this.$route.matched.length === 0) {
        return
      }

      switch (this.$route.meta.template) {
        case 'auth':
          return AuthTemplate
        case 'main':
          return MainTemplate
        default:
          throw new Error('Route did not define a template in meta.')
      }
    }
  }
}
</script>
